import { PropsWithChildren, forwardRef } from "react";
import { Box, Stack } from "@mui/material";

/**
 * a sidebar shown on the right side of the canvas.
 * it allows scrolling when there are too many elements
 * @param children
 * @param height height of the sidebar, should be so it closes with the end of the canvas
 * @param width the width of the sidebar
 */

type Props = {
  height: number;
  width: number;
  overflow: string;
};

export const InfoSideBar = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, width, overflow }, ref) => {
    return (
      <Box
        data-testid="InfoSideBar-box-parent"
        ref={ref}
        overflow={overflow}
        maxHeight={"85vh"}
        sx={{
          position: "absolute",
          top: 65,
          right: 0,
          m: 1
        }}
      >
        <Stack width={width} gap={1} data-testid="InfoSideBar-stack-parent">
          <div ref={ref}>{children}</div>
        </Stack>
      </Box>
    );
  }
);
